(function () {
  function invariantAssign(el, msg) {
    if (!el) throw new Error(msg);
    return el;
  }

  class ProductCustomizer extends HTMLElement {
    constructor() {
      super();

      this.items = Array.from(this.querySelectorAll('[data-item]'));
      this.total = invariantAssign(
        this.querySelector('[data-total]'),
        'Total Container could not be found'
      );
      this.preorderContainer = this.querySelector('[data-preorder-msg]');
      this.addToCartButton = invariantAssign(
        this.querySelector('[data-add-to-cart]'),
        'Add to cart could not be found'
      );

      this.cartItems =
        document.querySelector('#cart_container_id') ||
        document.querySelector('cart-items') ||
        document.querySelector('[data-cart-items]') ||
        null;

      const customizedJson = this.querySelector('#customizedJSON');
      const parsedJson =
        customizedJson && customizedJson.textContent
          ? JSON.parse(customizedJson.textContent)
          : null;

      this.optionsArray = parsedJson?.options ? parsedJson.options : [];

      const products = this.querySelector('#collectionJSON');
      const productsJson =
        products && products.textContent ? JSON.parse(products.textContent) : [];

      const products2 = this.querySelector('#collection2JSON');
      const products2Json =
        products2 && products2.textContent ? JSON.parse(products2.textContent) : [];

      this.products = Array.isArray(productsJson) ? productsJson : [];
      if (Array.isArray(products2Json)) this.products = this.products.concat(products2Json);

      this.dpi = window.devicePixelRatio || 1;
      this.canvas = document.querySelector('#builder-canvas');
      this.context = this.canvas ? this.canvas.getContext('2d') : null;
      this.size = 0;

      this.cart = [];
      this.images = [];

      const baseOptions = this.optionsArray.slice();
      baseOptions.forEach((option) => {
        if (option?.multiSelection) {
          option.multiSelection.forEach((m) => {
            this.optionsArray.push({
              label: m.label,
              selections: m.selections,
              hide: m.hide,
              multiSelection: null,
            });
          });
        }
      });

      this.isBundle = this.hasAttribute('data-bundle');
      this.bundleSet = this.querySelectorAll('[data-selected-variant-id]');
      const parentJSONText = document.getElementById('parentJSON')?.textContent;
      this.bundleData = parentJSONText ? JSON.parse(parentJSONText) : [];
    }

    connectedCallback() {
      this.preselectFirstOption();

      this.items.forEach((el) => {
        el.addEventListener('click', () => {
          this.setOption(el);
          this.hideOptions();
          this.buildCart();
          this.calculateTotals();
          this.createCanvas().catch((e) => console.error('Error creating canvas:', e));
        });
      });

      this.addToCartButton.addEventListener('click', () => {
        this.addToCart().catch((e) => console.error('Error adding to cart:', e));
      });

      window.addEventListener(
        'resize',
        () => {
          this.setupCanvas();
          this.createCanvas().catch((e) => console.error('Error creating canvas:', e));
        },
        true
      );
    }

    resolveCartController() {
      const c = this.cartItems;
      return c && typeof c.addItem === 'function' ? c : null;
    }

    async addToCartFallback(items) {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: [] }),
      });

      const parsed = await resp.json().catch(() => ({}));

      if (window.ajaxCart?.load) window.ajaxCart.load();
      document.querySelector('#cart-icon-bubble')?.click();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { items } }));

      return parsed;
    }

    buildCart() {
      this.cart = [];
      const activeItems = Array.from(this.querySelectorAll('[data-active]'));
      this.images = [];
      const activeOptions = activeItems.map((el) => el.dataset.item);

      activeItems.forEach((el) => {
        const value = el.dataset.item;
        const parent = el.closest('[data-option]');
        if (!parent) return;
        const key = parent.dataset.option;
        if (!key || !value) return;

        const options = this.optionsArray.find((x) => x?.label === key);
        if (!options) return;

        const option = options.selections?.find((x) => x?.key === value);
        if (!option) return;

        let items = option.products || [];
        const isHidden = el.closest('[data-hide-option]');

        if (option.images && isHidden && !isHidden.classList.contains('hidden')) {
          this.images = this.images.concat(option.images);
        }

        if (option.image_condition && isHidden && !isHidden.classList.contains('hidden')) {
          Object.keys(option.image_condition).forEach((k) => {
            let conditions = k.split('|');
            const excludesIndex = conditions.findIndex((s) => s.includes('!'));
            let excludes = [];
            if (excludesIndex !== -1) {
              if (conditions[excludesIndex]) excludes.push(conditions[excludesIndex].replace('!', ''));
              conditions.splice(excludesIndex, 1);
            }
            conditions = conditions.map((c) => c.replace('"', ''));
            excludes = excludes.map((e) => e.replace('"', ''));

            const ok =
              conditions.every((c) => activeOptions.includes(c)) &&
              activeOptions.some((r) => r && excludes.includes(r)) !== true;

            if (!ok) return;

            const foundImages = option.image_condition[k];
            if (!foundImages) return;

            if (option.image_position === 'prepend') {
              this.images = foundImages.concat(this.images);
            } else {
              this.images = this.images.concat(foundImages);
            }
          });
        }

        const productCondition = option.product_condition || {};
        Object.keys(productCondition).forEach((k) => {
          let conditions = k.split('|');
          const excludesIndex = conditions.findIndex((s) => s.includes('!'));
          let excludes = [];
          if (excludesIndex !== -1) {
            if (conditions[excludesIndex]) excludes.push(conditions[excludesIndex].replace('!', ''));
            conditions.splice(excludesIndex, 1);
          }
          conditions = conditions.map((c) => c.replace('"', ''));
          excludes = excludes.map((e) => e.replace('"', ''));

          const ok =
            conditions.every((c) => activeOptions.includes(c)) &&
            activeOptions.some((r) => r && excludes.includes(r)) !== true;

          if (!ok) return;

          if (productCondition[k]) items = items.concat(productCondition[k]);
        });

        items.forEach((item) => {
          const [id, variantId] = String(item || '').split(':');
          if (!id || !variantId) return;

          const product = this.products.find((x) => x?.id === Number(id));
          const variants = product?.variants;
          if (!variants) return;

          let variant = null;

          if (!/^\d+$/.test(variantId)) {
            let updatedVariantId = variantId;

            this.optionsArray.forEach((opt) => {
              if (!opt?.label) return;
              const token = `<${opt.label}>`;
              if (!updatedVariantId.includes(token)) return;

              const optionEl = this.querySelector(`[data-option="${opt.label}"]`);
              if (!optionEl) return;

              const selected = optionEl.querySelector('[data-active]')?.dataset.item;
              if (!selected) return;

              updatedVariantId = updatedVariantId.replace(token, selected);
            });

            variant = variants.find((v) => v?.title === updatedVariantId) || null;
          } else {
            variant = variants.find((v) => String(v?.id) === String(variantId)) || null;
          }

          if (variant && isHidden && !isHidden.classList.contains('hidden')) {
            this.cart.push(variant);
          }
        });
      });
    }

    hideOptions() {
      this.optionsArray.forEach((option) => {
        const optionContainer = this.querySelector(`[data-option="${option.label}"]`);

        option.selections?.forEach((opt) => {
          if (!opt?.hide) return;

          opt.hide.forEach((item) => {
            const depKey = Object.keys(item)[0];
            const dOpt = this.querySelector(`[data-option="${depKey}"]`);
            if (!dOpt) return;

            const optionValue = String(opt.value || '').replace('"', '');
            const val = dOpt.querySelector('[data-active]');
            const li = optionContainer?.querySelector(`[data-item='${optionValue}']`);
            if (!li) return;

            let selectedWidth = Object.values(item)[0];
            if (selectedWidth) selectedWidth = selectedWidth.replace('"', '');

            if (val && val.dataset.item === selectedWidth) {
              li.classList.add('hidden');
              delete li.dataset.active;
            } else {
              li.classList.remove('hidden');
            }
          });
        });

        if (option.hide) {
          let hide = false;

          option.hide.forEach((item) => {
            const depKey = Object.keys(item)[0];
            const dOption = this.querySelector(`[data-option="${depKey}"]`);
            if (!dOption) return;

            const val = dOption.querySelector('[data-active]');
            if (val && val.dataset.item === Object.values(item)[0]) hide = true;
          });

          const block = this.querySelector(`[data-hide-option="${option.label}"]`);
          if (block) block.classList.toggle('hidden', hide);
        }

        const hasActive = optionContainer?.querySelector('[data-active]');
        if (!hasActive) {
          const firstAvailable = optionContainer?.querySelector('li:not(.hidden)');
          if (firstAvailable) firstAvailable.click();
        }
      });
    }

    setOption(el) {
      const ul = el.closest('ul');
      const parent = el.closest('[data-hide-option]');

      if (parent) {
        const selectedSpan = parent.querySelector('[data-option-selected]');
        if (selectedSpan) selectedSpan.innerText = el.innerText;
      }

      if (!ul) return;

      ul.querySelectorAll('li').forEach((item) => delete item.dataset.active);
      el.dataset.active = 'true';
    }

    preloadImages(urls) {
      return Promise.all(
        (urls || []).map((url) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.src = url;
            img.loading = 'eager';
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`Image failed to load: ${url}`));
          }).catch((e) => console.error(e))
        )
      );
    }

    async createCanvas() {
      if (!this.context || !this.canvas) return;

      this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
      const images = await this.preloadImages(this.images);

      this.context.imageSmoothingEnabled = false;
      images.forEach((img) => {
        if (img instanceof HTMLImageElement) {
          this.context.drawImage(img, 0, 0, this.size * this.dpi, this.size * this.dpi);
        }
      });
    }

    setupCanvas() {
        if (!this.canvas) return;

        let container =
            this.querySelector('[data-image-container]') ||
            document.querySelector('[data-image-container]');

        if (!container) {
            container = this.canvas.parentElement;
        }
        if (!container) return;

        const size = container.clientWidth || container.getBoundingClientRect().width;
        this.size = Math.round(size);

        this.dpi = window.devicePixelRatio || 1;

        if (this.size > 0) {
            const px = this.size + 'px';
            const dim = String(Math.round(this.size * this.dpi));

            this.canvas.setAttribute('width', dim);
            this.canvas.setAttribute('height', dim);
            this.canvas.dataset.active = 'true';
        }

        if (!this.context) {
            this.context = this.canvas.getContext('2d');
        }
    }

    setPreorder(preorder, available = true) {
      if (!this.preorderContainer) return;

      if (preorder && available) {
        this.addToCartButton.textContent = 'Pre-Order';
        const span = this.preorderContainer.querySelector('span');
        if (span) span.innerText = preorder;
        this.preorderContainer.dataset.preorder = 'true';
      } else {
        this.preorderContainer.dataset.preorder = 'false';
      }
    }

    preselectFirstOption() {
      const uls = this.querySelectorAll('[data-option]');
      uls.forEach((ul) => {
        const first = ul.querySelector('li');
        if (first) this.setOption(first);
      });

      this.hideOptions();
      this.buildCart();
      this.calculateTotals();
      this.setupCanvas();
      this.createCanvas().catch((e) => console.error('Error creating canvas:', e));
    }

    calculateTotals() {
      const preorder = null;
      let total = 0;
      let isAvailable = true;

      this.cart.forEach((variant) => {
        total += (variant.price || 0) / 100;
        if (variant.available === false) isAvailable = false;
      });

      const container = this.querySelector('[data-selected-variants-inputs]');
      if (!container) return;
      container.innerHTML = '';
      this.cart.forEach((variant) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selected_variant_ids[]';
        input.value = variant.id;
        input.dataset.selectedVariantId = variant.id;

        container.appendChild(input);
      });

      this.setAvailability(isAvailable);
      this.setPreorder(preorder, isAvailable);
      this.total.innerHTML = total.toFixed(2);
    }

    setAvailability(isAvailable) {
      if (!this.addToCartButton) return;

      this.addToCartButton.textContent = isAvailable ? 'Add to cart' : 'Out of Stock';

      if (isAvailable) {
        this.addToCartButton.removeAttribute('disabled');
        this.addToCartButton.removeAttribute('aria-disabled');
        this.addToCartButton.classList.remove('is-disabled');
      } else {
        this.addToCartButton.setAttribute('disabled', 'true');
        this.addToCartButton.setAttribute('aria-disabled', 'true');
        this.addToCartButton.classList.add('is-disabled');
      }
    }

    buildBundleItems() {
      const items = [];

      const parentData = this.isBundle
        ? JSON.parse(document.getElementById('parentJSON')?.textContent || 'null')
        : null;

    if (!this.isBundle || !Array.isArray(parentData)) return { items, selectedJSON: null };

    const selectedParentIds = Array.from(this.querySelectorAll('[data-selected-variant-id]'))
      .map((el) => String(el.dataset.selectedVariantId || '').trim())
      .filter(Boolean);

    if (!selectedParentIds.length) return { items, selectedJSON: null };

    const parentQty = new Map();
    selectedParentIds.forEach((id) => parentQty.set(id, (parentQty.get(id) || 0) + 1));

    const selectedJSONs = [];

    parentQty.forEach((bundleCount, parentId) => {
      const selectedJSON =
        parentData.find((b) => String(b?.item?.parentID) === String(parentId)) || null;

      if (!selectedJSON) return;

      selectedJSONs.push(selectedJSON);

      const children = Array.isArray(selectedJSON.item.childrenID)
        ? selectedJSON.item.childrenID
        : [selectedJSON.item.childrenID].filter(Boolean);

      const priceParts = String(selectedJSON.item.price || '').split(':');
      const priceValue = priceParts.length > 1 ? priceParts[1] : String(selectedJSON.item.price || '');
      const priceCorrection = `MultiPurchaseBundle:${priceValue}`;

      children.forEach((c) => {
        const parts = String(c || '').trim().split(':');
        if (parts.length < 2) return;

        const id = parts[0].trim(); // string, щоб не ловити проблеми з великими числами
        const baseQty = parseInt(parts[1].trim(), 10);
        if (!id || !Number.isFinite(baseQty) || baseQty <= 0) return;

        const quantity = baseQty * bundleCount;
        const preOrderItem = this.querySelector('[data-preorder-date]');
        const shipDateRaw = preOrderItem?.getAttribute('data-preorder-date') || '';
        console.log('shipDateRaw', shipDateRaw);

        items.push({
          id,
          quantity,
          properties: {
            'Ship Date': shipDateRaw,
            _bundleId: selectedJSON.item.parentID,
            _priceCorrection: priceCorrection,
            _parentSKU: selectedJSON.item._bundleId || selectedJSON.item.parentSKU || '',
            _originalQuant: baseQty,
            _bundleData: JSON.stringify({
              id,
              quantity,
              properties: {
                _bundleId: selectedJSON.item.parentID,
                _parentSKU: selectedJSON.item._bundleId || selectedJSON.item.parentSKU || '',
                _priceCorrection: priceCorrection,
                _originalQuant: baseQty,
              },
            }),
          },
        });
      });
    });

    if (!items.length) return { items: [], selectedJSON: null };

      return { items, selectedJSON: selectedJSONs };
    }

    buildRegularItemsFromCart() {
      const items = [];
      this.cart.forEach((variant) => {
        if (!variant?.available) return;
        const id = Number(variant.id);
        if (!id) return;
        const existing = items.find((x) => x.id === id);
        if (existing) existing.quantity += 1;
        else items.push({ id, quantity: 1 });
      });
      return items;
    }

    async addToCart() {
      let items = [];

      const { items: bundleItems, selectedJSON } = this.buildBundleItems();
      if (selectedJSON) items = bundleItems;
      else items = this.buildRegularItemsFromCart();

      if (!items.length) return;

      const controller = this.resolveCartController();
      if (controller) {
        try {
          controller.addItem(0, items, true);
          return;
        } catch (e) {
          console.warn('cartItems.addItem failed, fallback to AJAX', e);
        }
      }

      await this.addToCartFallback(items);
    }
  }

  if (!customElements.get('product-customizer')) {
    customElements.define('product-customizer', ProductCustomizer);
  }
})();


(function () {
  function invariantAssign(el, msg) {
    if (!el) throw new Error(msg);
    return el;
  }

  const baseAnimation = {
    parent: [],
    container: ['group/tab'],
    accordions: [
      'overflow-hidden',
      'transition-[height]',
      'duration-500',
      'ease-in-out',
    ],
  };

  const attributes = {
    accordionId: { selector: 'data-accordion-id' },
    expanded: { selector: 'data-expanded', true: 'true' },
    toggle: { selector: 'data-accordion-toggle' },
    content: { selector: 'data-accordion-content' },
  };

  class TabAccordion extends HTMLElement {
    static get observedAttributes() {
      return [attributes.expanded.selector];
    }

    constructor() {
      super();

      this.parentEl = this.parentElement ? this.parentElement.tagName : '';
      this.content = this.querySelector(`[${attributes.content.selector}]`);

      this.accordionId = invariantAssign(
        this.dataset.accordionId,
        `All accordions must have an id assigned. Add ${attributes.accordionId.selector}.`
      );

      this.toggleSwitches = Array.from(
        this.querySelectorAll(`[${attributes.toggle.selector}]`)
      ).filter((t) => t.closest('tab-accordion') === this);

      if (this.toggleSwitches.length === 0) {
        throw new Error(`No toggles found for accordion ${this.accordionId}`);
      }

      this._onTransitionStart = () => (this.dataset.isAnimating = 'true');

      this._onTransitionEnd = () => {
        delete this.dataset.isAnimating;
        if (!this.content) return;
        this.content.style.height = 'expanded' in this.dataset ? 'auto' : '0px';
      };

      this._toggle = () => {
        if ('expanded' in this.dataset) delete this.dataset.expanded;
        else this.dataset.expanded = attributes.expanded.true;
      };

      this._intersectionObs = null;
    }

    connectedCallback() {
      if (!('manualCSS' in this.dataset)) {
        this.parentElement?.classList.add(...baseAnimation.parent);
        this.classList.add(...baseAnimation.container);
        this.content?.classList.add(...baseAnimation.accordions);
        if (this.content) this.content.style.height = '0px';
      }

      this._intersectionObs = new IntersectionObserver(
        (entries) => {
          const e = entries[0];
          if (!e) return;
          if (!e.isIntersecting && 'isAnimating' in this.dataset) {
            const top = this.getBoundingClientRect().top;
            if (top < 0 && this.content) this.content.scrollIntoView({ behavior: 'smooth' });
          }
        },
        { threshold: 1, rootMargin: '24px' }
      );
      this._intersectionObs.observe(this);

      this.addEventListener('transitionstart', this._onTransitionStart);
      this.addEventListener('transitionend', this._onTransitionEnd);

      if (this.parentEl !== 'TAB-ACCORDION-GROUP') {
        this.toggleSwitches.forEach((t) => t.addEventListener('click', this._toggle));
      }

      if (this.content) {
        if ('expanded' in this.dataset) {
          this.content.style.height = `${this.content.scrollHeight}px`;
          requestAnimationFrame(() => {
            if (this.content && 'expanded' in this.dataset) this.content.style.height = 'auto';
          });
        } else if (!('manualCSS' in this.dataset)) {
          this.content.style.height = '0px';
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('transitionstart', this._onTransitionStart);
      this.removeEventListener('transitionend', this._onTransitionEnd);
      this.toggleSwitches.forEach((t) => t.removeEventListener('click', this._toggle));

      if (this._intersectionObs) {
        this._intersectionObs.disconnect();
        this._intersectionObs = null;
      }
    }

    attributeChangedCallback(name, _oldValue, newValue) {
      if (name !== attributes.expanded.selector) return;
      if (!this.content) return;

      if (newValue === attributes.expanded.true) {
        this.content.style.height = `${this.content.scrollHeight}px`;
      } else {
        this.content.style.height = `${this.content.scrollHeight}px`;
        requestAnimationFrame(() => {
          if (this.content) this.content.style.height = '0px';
        });
      }
    }
  }

  class TabAccordionGroup extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const toggle = e.target?.closest?.(`[${attributes.toggle.selector}]`);
        if (!toggle) return;

        const acc = toggle.closest('tab-accordion');
        if (!acc || acc.parentElement !== this) return;

        this.querySelectorAll('tab-accordion').forEach((el) => {
          if (el !== acc) el.removeAttribute(attributes.expanded.selector);
        });

        if (acc.hasAttribute(attributes.expanded.selector)) acc.removeAttribute(attributes.expanded.selector);
        else acc.setAttribute(attributes.expanded.selector, attributes.expanded.true);
      });
    }
  }

  if (!customElements.get('tab-accordion')) customElements.define('tab-accordion', TabAccordion);
  if (!customElements.get('tab-accordion-group')) customElements.define('tab-accordion-group', TabAccordionGroup);
})();